import styled from 'styled-components';

import { COLORS, GRADIENTS } from '@/nova/theme/tokens';
import { Text } from '@/nova/components';

/** A campaign card: a leading thumbnail beside the name/URL/status column. */
export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

/** Square campaign thumbnail. Holds the Ad Service key-art when we have it; otherwise its own
 *  gradient surface + a centered glyph is the premium placeholder (same aesthetic as CreativeCard's
 *  empty art). */
export const Thumb = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 12px;
  overflow: hidden;
  background: ${GRADIENTS.featureCard};
  display: grid;
  place-items: center;
  color: ${COLORS.textFaint};
`;

export const ThumbImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Meta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const UrlText = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Dates = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textFaint};
`;
